var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page"
  }, [_c('h1', {
    staticClass: "form-title"
  }, [_vm._v("請詳實填寫收件資訊")]), _c('div', {
    staticClass: "my-4 mx-2 field"
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('label', {
    staticClass: "field__label field--required"
  }, [_vm._v(" 收件姓名 ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer_name,
      expression: "customer_name"
    }],
    staticClass: "field__input",
    class: {
      invalid: _vm.v$.customer_name.$error
    },
    attrs: {
      "placeholder": "請輸入收件名稱"
    },
    domProps: {
      "value": _vm.customer_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.customer_name = $event.target.value;
      }
    }
  }), _vm.v$.customer_name.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 輸入的資料未填寫 ")]) : _vm._e()]), _c('div', {
    staticClass: "my-4"
  }, [_c('label', {
    staticClass: "field__label field--required"
  }, [_vm._v(" 收件地址 ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer_address,
      expression: "customer_address"
    }],
    staticClass: "field__input",
    class: {
      invalid: _vm.v$.customer_address.$error
    },
    attrs: {
      "placeholder": "請輸入收件地址"
    },
    domProps: {
      "value": _vm.customer_address
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.customer_address = $event.target.value;
      }
    }
  }), _vm.v$.customer_address.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 輸入的資料未填寫或輸入特殊字元＠ ")]) : _vm._e()]), _c('div', {
    staticClass: "my-4"
  }, [_c('label', {
    staticClass: "field__label field--required"
  }, [_vm._v(" 聯絡電話 ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer_mobile,
      expression: "customer_mobile"
    }],
    staticClass: "field__input",
    class: {
      invalid: _vm.v$.customer_mobile.$error
    },
    attrs: {
      "placeholder": "請輸入聯絡電話"
    },
    domProps: {
      "value": _vm.customer_mobile
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.customer_mobile = $event.target.value;
      }
    }
  }), _vm.v$.customer_mobile.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 輸入的資料未填寫 ")]) : _vm._e()])]), _vm._m(0), _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(" 送出 ")])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "reward-notice s-p-3"
  }, [_c('ol', [_c('li', [_vm._v("請勿必詳實填寫贈品收件資訊。")]), _c('li', [_vm._v(" 如因填寫資訊有誤致使贈獎程序無法完成，衍生之成本與寄送責任應由贈獎者自行負擔。 ")])])]);
}]

export { render, staticRenderFns }